import { Component } from "./component"
import { handleComponentError } from "../decorators/handleComponentError"
import { FooterComponents } from "../types/footerComponents.interface"

export class FooterComponent extends Component<{}, FooterComponents> {
    private setAlignment(alignment?: string) {
        if (this.element) {
            this.element.style.justifyContent = alignment || "normal"
        }
    }

    @handleComponentError("FooterComponent")
    render() {
        this.setBackgroundColor(this.props.backgroundColor)
        this.setAlignment(this.props.alignment)
        this.show(this.props.isVisible)
        super.render()
    }
}
